import Vue from 'vue/dist/vue.esm';
// LOADING GLOBAL COMPONENTS



	
	
	import componentMyMultiSelect from "/var/www/myapp/app/webpacker/javascripts/components/global/myMultiSelect.vue";
	Vue.component("vue-my-multi-select", componentMyMultiSelect);

	
	
	import componentMySelect from "/var/www/myapp/app/webpacker/javascripts/components/global/mySelect.vue";
	Vue.component("vue-my-select", componentMySelect);

	
	
	import componentFileInput from "/var/www/myapp/app/webpacker/javascripts/components/global/fileInput.vue";
	Vue.component("vue-file-input", componentFileInput);

	
	
	import componentMyCalendar from "/var/www/myapp/app/webpacker/javascripts/components/global/myCalendar.vue";
	Vue.component("vue-my-calendar", componentMyCalendar);

	
	
	import componentSidebar from "/var/www/myapp/app/webpacker/javascripts/components/global/sidebar.vue";
	Vue.component("vue-sidebar", componentSidebar);

	
	
	import componentModal from "/var/www/myapp/app/webpacker/javascripts/components/global/modal.vue";
	Vue.component("vue-modal", componentModal);

	
	
	import componentAlert from "/var/www/myapp/app/webpacker/javascripts/components/global/alert.vue";
	Vue.component("vue-alert", componentAlert);

	
	
	import componentDynamicList from "/var/www/myapp/app/webpacker/javascripts/components/global/dynamicList.vue";
	Vue.component("vue-dynamic-list", componentDynamicList);

	
	
	import componentDateString from "/var/www/myapp/app/webpacker/javascripts/components/global/dateString.vue";
	Vue.component("vue-date-string", componentDateString);

	
	
	import componentNavTabs from "/var/www/myapp/app/webpacker/javascripts/components/global/navTabs.vue";
	Vue.component("vue-nav-tabs", componentNavTabs);

	
	
	import componentTimeString from "/var/www/myapp/app/webpacker/javascripts/components/global/timeString.vue";
	Vue.component("vue-time-string", componentTimeString);

	
	
	import componentDynamicListItem from "/var/www/myapp/app/webpacker/javascripts/components/global/dynamicListItem.vue";
	Vue.component("vue-dynamic-list-item", componentDynamicListItem);

	
	
	import componentTab from "/var/www/myapp/app/webpacker/javascripts/components/global/tab.vue";
	Vue.component("vue-tab", componentTab);

	
	
	import componentDirective from "/var/www/myapp/app/webpacker/javascripts/components/global/directive.vue";
	Vue.component("vue-directive", componentDirective);

	
	
	import componentAccordion from "/var/www/myapp/app/webpacker/javascripts/components/global/accordion.vue";
	Vue.component("vue-accordion", componentAccordion);


// LOADING PAGE SPECIFIC COMPONENTS
import componentMeetForm from './admin/meets/form/form.vue';
import componentSelectTag from './admin/meets/form/selectTag.vue';
import componentMeetOperation from './admin/meets/operation/main.vue'
import componentMeetShowTopicCard from './admin/meets/showTopicCard.vue';
import componentTenantForm from './admin/tenants/form.vue';

import componentTasks from './admin/tasks/tasks.vue';
import componentTaskSidebar from './admin/tasks/taskSidebar.vue';
import componentBaseTaskCard from './admin/tasks/baseTaskCard.vue';
import componentFormTaskCard from './admin/tasks/formTaskCard.vue';
import componentSavedTaskCard from './admin/tasks/savedTaskCard.vue';
import componentTaskCard from './admin/tasks/taskCard.vue';
import componentTaskErrorWindow from './admin/tasks/taskErrorWindow.vue';
import componentTaskCardMenu from './admin/tasks/taskCardMenu.vue';
import componentTimeTask from './admin/tasks/timeTask.vue';
import componentTaskTags from './admin/tasks/taskTags.vue';
import componentTaskTag from './admin/tasks/taskTag.vue';
import componentTimer from './admin/tasks/timer.vue';
import componentTaskListItem from './admin/tasks/taskListItem.vue';
import componentDescriptionSavedTaskCard from './admin/tasks/descriptionSavedTaskCard.vue';


Vue.component('vue-admin-meets-form', componentMeetForm);
Vue.component('vue-admin-meets-select-tag', componentSelectTag);
Vue.component('vue-admin-meets-show-topic-card', componentMeetShowTopicCard);
Vue.component('vue-meets-operation', componentMeetOperation);
Vue.component('vue-admin-tenants-form', componentTenantForm);

Vue.component('vue-admin-tasks-tasks', componentTasks)
Vue.component('vue-admin-tasks-task-sidebar', componentTaskSidebar);
Vue.component('vue-admin-tasks-base-task-card', componentBaseTaskCard);
Vue.component('vue-admin-tasks-form-task-card', componentFormTaskCard);
Vue.component('vue-admin-tasks-task-card', componentTaskCard);
Vue.component('vue-admin-tasks-task-error-window', componentTaskErrorWindow);
Vue.component('vue-admin-tasks-time-task', componentTimeTask);
Vue.component('vue-admin-tasks-task-tags', componentTaskTags);
Vue.component('vue-admin-tasks-task-tag', componentTaskTag);
Vue.component('vue-admin-tasks-saved-task-card', componentSavedTaskCard);
Vue.component('vue-admin-tasks-task-card-menu', componentTaskCardMenu);
Vue.component('vue-admin-tasks-timer', componentTimer);
Vue.component('vue-admin-tasks-description-saved-task-time', componentDescriptionSavedTaskCard);
Vue.component('vue-admin-tasks-task-list-item', componentTaskListItem);



